<template>
  <div class="reverseInvoiceList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="sd/cancelInvoice/pageList">
      <template slot="adSearch">
        <vm-search label="发票日期">
          <div class="block">
            <el-date-picker
                v-model="filter.cancelInvoiceDateBegin"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.cancelInvoiceDateEnd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="冲销发票号">
          <el-input v-model.trim="filter.cancelInvoiceNo" clearable/>
        </vm-search>
        <vm-search label="客户">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="创建日期">
          <div class="block">
            <el-date-picker
                v-model="filter.createDateBegin"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.createDateEnd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
      </template>
      <el-table-column align="center" prop="cancelInvoiceNo" label="冲销发票号"/>
      <el-table-column align="center" prop="cancelInvoiceDate" label="发票日期">
        <template slot-scope="scope">
          <span>{{scope.row.cancelInvoiceDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="invoiceNo" label="原发票号"/>
      <el-table-column align="center" prop="invoiceDate" label="原发票日期">
        <template slot-scope="scope">
          <span>{{scope.row.invoiceDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="cancelInvoiceType" label="发票类型"/>
      <el-table-column align="center" prop="customerName" label="客户"/>
      <el-table-column align="center" prop="createDate" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "ReverseInvoiceList",
    components: { VmTable, VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          cancelInvoiceNo: "",
          customerName: "",
          cancelInvoiceDateBegin: "",
          cancelInvoiceDateEnd: "",
          createDateBegin: "",
          createDateEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>
<style lang="scss">
</style>
